"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("@jsluna/button");

var _card = require("@jsluna/card");

var _grid = require("@jsluna/grid");

var _icons = require("@jsluna/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AddQuestionSection = function AddQuestionSection(_ref) {
  var options = _ref.options,
      addQuestion = _ref.addQuestion,
      showOptions = _ref.showOptions,
      setShowOptions = _ref.setShowOptions;

  var handleClose = function handleClose() {
    setShowOptions(false);
  };

  var handleAddQuestion = function handleAddQuestion(component) {
    addQuestion(component);
  };

  return /*#__PURE__*/_react.default.createElement("div", null, !showOptions && /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      md: '1/2'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    onClick: function onClick() {
      return setShowOptions(true);
    },
    className: "ln-u-bg-color-white"
  }, "Add something new"))), showOptions && /*#__PURE__*/_react.default.createElement(_card.Card, {
    className: "ln-u-bg-color-light"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "4/5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Add something new")), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/5",
    className: "ln-u-text-align-right ln-u-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    label: "Close option menu",
    color: "dark",
    hideLabel: true,
    onClick: function onClick() {
      return handleClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Cancel, null))), showOptions && options.map(function (x) {
    return /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, {
      key: x.componentType
    }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/1"
    }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: {
        default: '1/1',
        md: '1/2'
      },
      className: "ln-u-padding-ends"
    }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
      fullWidth: true,
      onClick: function onClick() {
        handleAddQuestion(x.componentType);
      },
      className: "ln-u-bg-color-white"
    }, x.displayName))));
  }))));
};

AddQuestionSection.propTypes = {
  /** An array of the survey components available */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The display name of the component to surface on the option */
    displayName: _propTypes.default.string,

    /** The component that should be added when selecting this option */
    componentType: _propTypes.default.string
  })).isRequired,

  /** Function to add the component that has been selected */
  addQuestion: _propTypes.default.func.isRequired,

  /** Controls whether the list of question options should be shown */
  showOptions: _propTypes.default.bool.isRequired,

  /** Function to update the value of `showOptions` */
  setShowOptions: _propTypes.default.func.isRequired
};
var _default = AddQuestionSection;
exports.default = _default;